import React from "react";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

const Track = ({ source, target, getTrackProps }) => (
  <div
    style={{
      left: `${source.percent}%`,
      width: `${target.percent - source.percent}%`,
    }}
    className={styles.track}
    {...getTrackProps()}
  />
);

Track.propTypes = {
  source: PropTypes.shape({
    percent: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired,
  }).isRequired,
  target: PropTypes.shape({
    percent: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
      .isRequired,
  }).isRequired,
  getTrackProps: PropTypes.func.isRequired,
};

export default Track;
